<template>
  <!-- 新闻图文列表 -->
  <div id="app-council">
    <div class="council-box">
      <div class="list-box" v-for="(item,index) in listData.data" :key="index" @click="goDetails(item.id,cid)">
        <div class="list-l">
          <img :src="item.news_pic_url" alt />
          <div class="info-box">
            <a href="javaScript:;">
              <h5>{{item.news_title}}</h5>
              <p>{{item.description}}</p>
              <span>{{item.custom_time}}</span>
            </a>
          </div>
        </div>
        <a href="javascript:;">
          <div class="list-r">
            <h5>更多</h5>
            <p>more</p>
          </div>
        </a>
      </div>
      <div class="page-box" v-if="listData.total > $db.config.newsListSize1">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="listData.current_page"
          :page-size="$db.config.newsListSize1"
          :total="listData.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["chid", "type"],
  data() {
    return {
      cid: null,
      tabid: null,
      listData: []
    };
  },
  methods: {
    getList(page) {
      //获取列表信息
      this.$db
        .post(this.$db.config.getDataByChidUrl, {
          id: this.chid,
          page_size: this.$db.config.newsListSize1,
          page: page
        })
        .then(res => {
          this.listData = res.data;
        });
    },
    //跳转详情页面
    goDetails(id, cid) {
      if (this.type && this.type == 3) {
        //项目新闻
        this.$router.push({
          name: "projectDetails",
          query: { id: id, cid: cid }
        });
      } else {
        this.$router.push({
          name: "pubDetails",
          query: { id: id, cid: cid }
        });
      }
    },
    //改变页码
    handleCurrentChange(val) {
      this.getList(val);
    }
  },
  watch: {
    chid: function(val) {
      this.getList(1);
    }
  },
  created() {
    this.cid = this.$route.query.cid;
    this.tabid = this.$route.query.tabid;
    this.getList(1);
  }
};
</script>

<style lang="scss" scoped>
#app-council {
  width: 100%;
  margin: 37px 0;
}
.council-box {
  width: 1300px;
  margin: 0 auto;
  .list-box {
    padding: 15px 17px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    transition: ease-in 0.6s;
    cursor: pointer;
    &:hover {
      transition: all 1.5s;
      background-color: #c30d23;
      box-shadow: 0px 0px 35px 0px rgba(9, 1, 4, 0.21);
      .list-l {
        .info-box {
          > a {
            > h5 {
              color: #fff;
            }
            > p {
              color: #fff;
            }
            > span {
              color: #fff;
            }
          }
        }
      }
      .list-r {
        > h5 {
          color: #fff;
        }
        > p {
          color: #fff;
        }
      }
    }
    .list-l {
      display: flex;
      > img {
        width: 280px;
        height: 210px;
        margin-right: 58px;
      }
      .info-box {
        > a {
          display: block;
          > h5 {
            width: 737px;
            font-size: 24px;
            color: #333;
            margin-bottom: 22px;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
            // font-weight: normal;
          }
          > p {
            text-indent: 2em;
            width: 737px;
            font-size: 14px;
            line-height: 26px;
            color: #333;
            margin-bottom: 45px;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          > span {
            font-size: 14px;
            color: #999;
          }
        }
      }
    }
    .list-r {
      width: 61px;
      margin: 70px 0;
      border-left: 1px solid #eee;
      > h5 {
        font-size: 14px;
        color: #333;
        font-weight: normal;
        text-align: center;
        padding-top: 13px;
      }
      > p {
        font-size: 14px;
        color: #333;
        text-align: center;
      }
    }
  }
  .page-box {
    text-align: center;
    margin-top: 20px;
  }
}
.page-box {
  text-align: center;
  margin-bottom: 70px;
}

.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #c30d23;
  color: #fff;
}
.page-box /deep/ .el-pagination.is-background .el-pager li {
  background-color: #fff;
  border: solid 1px #dddddd;
  color: #999;
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled):hover {
  color: #c30d23;
}
</style>



// WEBPACK FOOTER //
// src/components/Public/public_news.vue